import { Menu } from './menu';
import { IdentityUser } from './user';

/**
 * Obtiene el menú del usuario
 * @param {IdentityUser} user usuario
 * @returns {Menu[]} menú del usuario
 */
const getMenu = (user: IdentityUser): Menu[] => {
  if (!user.menu) {
    return [];
  }

  try {
    return JSON.parse(user.menu) as Menu[];
  } catch (error) {
    console.error('Error al parsear el menú del usuario', error);
    return [];
  }
};

/**
 * Operaciones de identidad
 */
export const IdentityOperations = {
  getMenu
};
